import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePrivateNotes } from "../../hooks/usePrivateNotes";
import { useNotesManagerStore } from "../../stores/notesManager";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

/**
 * 初回メモ保存後にワンタイムで暗号化を勧めるダイアログ
 *
 * 表示条件は PrivateNotesContext が管理（平文モード + 未表示フラグ + 最終編集から遅延）。
 * どの選択肢でも以後は表示しない。設定はプライベートメモ管理ダイアログへ誘導する
 */
export function EncryptionNudgeDialog() {
  const { t } = useTranslation();
  const { isEncryptionNudgeOpen, dismissEncryptionNudge } = usePrivateNotes();
  const openNotesManager = useNotesManagerStore((s) => s.open);

  return (
    <AlertDialog
      open={isEncryptionNudgeOpen}
      onOpenChange={(open) => {
        if (!open) dismissEncryptionNudge();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-green-600" />
            {t("privateMemo.encryption.nudgeTitle")}
          </AlertDialogTitle>
          {/* 本文は暗号化セクションの説明文と共通（文言の二重管理を避ける） */}
          <AlertDialogDescription>
            {t("privateMemo.encryption.plaintextDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="p-3 rounded-lg bg-amber-50 border border-amber-300">
          <p className="text-xs text-amber-900 leading-relaxed">
            {t("privateMemo.encryption.nudgeTradeoffs")}
          </p>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={dismissEncryptionNudge}>
            {t("privateMemo.encryption.nudgeLater")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              dismissEncryptionNudge();
              openNotesManager();
            }}
          >
            {t("privateMemo.encryption.plaintextNoticeAction")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
